var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('NcDatetimePicker',_vm._g(_vm._b({attrs:{"id":"my-datepicker"}},'NcDatetimePicker',_vm.$attrs,false),_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }